(function ($) {
    $(document).ready(function () {
        $(document).on('click', '.lpc_pick_up_widget_show_map', function () {
            $('html').css('overflow', 'hidden');

            $('#wc-backbone-modal-dialog').on('remove', function () {
                $('html').css('overflow', 'auto');
            });
        });
    });

})(jQuery);

